module.exports = __webpack_public_path__ + "img/Confirm-Package-en.23bc0b2.png";